import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ConsumerBusinessTradeFormSuccess = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center flex-col min-h-[40rem]"><h2 className="text-3xl font-bold">Thanks for your interest!</h2><p className="m-4">Your trade information has been submitted and will be reviewed shortly. Applications are usually reviewed within 24 - 48 hours.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ConsumerBusinessTradeFormSuccess;